// extracted by mini-css-extract-plugin
module.exports = {"modal_overlay":"modal-wide_modal_overlay__jsrlC","modal_wide":"modal-wide_modal_wide__tXRXZ","modal_box":"modal-wide_modal_box__zz5nD"};